'use client'
import { create } from 'zustand'

import type { PurchaseStepState, IsPurchaseState } from '@/shared/states/purchase/types'

export const usePurchaseStep = create<PurchaseStepState>((set) => ({
  purchaseStep: 0,
  setPurchaseStep: (step: number) => set({ purchaseStep: step }),
  // NOTE: 기존 purchaseStep 초기화 필요할 경우 사용 및 기존 로직 전환
  resetPurchaseStep: () => set({ purchaseStep: 0 })
}))

export const useIsPurchase = create<IsPurchaseState>((set) => ({
  isPurchase: false,
  setIsPurchase: (isPurchase: boolean) => set({ isPurchase: isPurchase }),
  // NOTE: 기존 isPurchase 초기화 필요할 경우 사용 및 기존 로직 전환
  resetIsPurchase: () => set({ isPurchase: false })
}))
